import {
    Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, Grid, GridItem, Image, Input, InputGroup, Text, Tooltip, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea,
    InputLeftElement,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverCloseButton,
    VStack,
} from "@chakra-ui/react";
import MyDiv from "./lead.style"
import CustomToast from "../../../components/CustomToast";
import { useFetch } from "../../../hooks/useFetch";
import { useEffect, useState, useRef } from "react";
import { CustomButton, CustomTable } from "../../../components";
import { Column } from "../../../components/customTable/CustomTable";
import { AddIcon, ChevronDownIcon, EditIcon, Search2Icon, TimeIcon, ViewIcon } from "@chakra-ui/icons";
import useDebounce from "../../../hooks/useDebounce";
import { LeadHistory, MyleadHistory, MyLeadList, MyleadViewDrawer } from "../components";
import { getStatusRank, ILead, ILeadTable } from "../LeadPool/model";
import LeadRequirementForm from "../components/LeadRequirementForm/leadRequirementForm";
import LeadRequirement from "../LeadRequirement";
import CustomPagination from "../../../components/CustomPagination";
import { useAuth } from "../../../hooks/useAuth";
import FilterCard, { IFilterOptions } from "../../../components/FilterCard/filterCard";
import { useLocation } from "react-router-dom";
import { pageMapping } from "../../../utilities/pageMapping";
import LegandIcon from "../../../assets/Images/Legend-Icon.svg"
import History from "../../../components/History";
import UniversalActivityHistory from "../../../components/History";
import DateRangePicker from "../../../components/DatePicker/datePicker";
import CreatedLeadList from "../components/CreatedLeadList";
// import UniversalActivityHistory from "../../../components/History/";



const sortOptions = [
    "Latest Leads",
    "Oldest Leads",
    "Recently Updated",
    // "Follow-up Due",
    "Hot Leads First",
    // "Recently Contacted",
    // "Proposal Pending",
    // "Negotiation Stage",
    "Company Name (A-Z)",
    "Company Name (Z-A)",
];

const sortMapping: Record<
    string,
    { field: string; order: 1 | -1 }
> = {
    "Latest Leads": { field: "createdAt", order: -1 },
    "Oldest Leads": { field: "createdAt", order: 1 },
    "Recently Updated": { field: "updatedAt", order: -1 },
    // "Follow-up Due": { field: "followUpDate", order: 1 },
    "Hot Leads First": { field: "priority", order: -1 },
    // "Recently Contacted": { field: "lastContacted", order: -1 },
    // "Proposal Pending": { field: "proposalStatus", order: 1 },
    // "Negotiation Stage": { field: "leadStatus", order: 1 },
    "Company Name (A-Z)": { field: "companyName", order: 1 },
    "Company Name (Z-A)": { field: "companyName", order: -1 },
};

const CreatedLead = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const fetchIdRef = useRef(0);
    const [leadData, setLeadData] = useState<ILeadTable>({ leads: [], totalCount: 0 });
    const [selectedLeads, setSelectedLeads] = useState<ILead | null>(null);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [search, setSearch] = useState("");
    const [isViewOpen, setIsViewOpen] = useState(false);
    const [viewLead, setViewLead] = useState<ILead | null>(null);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [historyLead, setHistoryLead] = useState<ILead | null>(null);
    const debounceSearch = useDebounce(search, 700);
    const [isStatusOpen, setIsStatusOpen] = useState(false);
    const [statusLead, setStatusLead] = useState<ILead | null>(null);
    const [statusOptions, setStatusOptions] = useState<{ id: number; label: string }[]>([]);
    const [statusReasonOptions, setStatusReasonOptions] = useState<{ id: number; label: string }[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<{ id: number; label: string } | null>(null);
    const [selectedStatusReason, setSelectedStatusReason] = useState<{ id: number; label: string } | null>(null);
    const [selectedDate, setSelectedDate] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [projectAmount, setProjectAmount] = useState("");
    const [projectDuration, setProjectDuration] = useState("");
    const [projectDurationType, setProjectDurationType] = useState<number>(2);
    const [isReqGatherFormOpen, setIsReqGatherFormOpen] = useState(false);
    const { userName, hasPermission } = useAuth(); const [expandedLeadId, setExpandedLeadId] = useState<number | null>(null);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 100, page: 0, sortField: '', sortOrder: 1, });
    const pageCount = Math.ceil(totalCount / lazyParams.rows);
    const [selectedSort, setSelectedSort] = useState(sortOptions[0]);
    const [isSortOpen, setIsSortOpen] = useState(false);
    const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
    const [maskingSettings, setMaskingSettings] = useState<any>({});
    const [selectedCard, setSelectedCard] = useState("");
    const [statusCounts, setStatusCounts] = useState<any[]>([]);
    const [isLegendOpen, setIsLegendOpen] = useState(false);
    const [allStatusCounts, setAllStatusCounts] = useState<any[]>([]);
    const [revealedField, setRevealedField] = useState<{ rowIndex: number | null; field: string | null; }>({ rowIndex: null, field: null, });
    const [revealedFields, setRevealedFields] = useState<{ rowIndex: number; field: string }[]>([]);
   
    const [dateRange, setDateRange] = useState<{
        start: Date;
        end: Date;
    } | null>(null);
    // FULL ROW REVEAL
    const [revealedRow, setRevealedRow] = useState<number | null>(null);
    const [activityCounts, setActivityCounts] = useState({
        reminders: 0,
        meetingScheduled: 0,
        meetingDone: 0,
        followUpDone: 0
    });



    const count = [
        { title: "Reminders", count: activityCounts.reminders },
        // { title: "Follow Up Done", count: activityCounts.followUpDone },
        { title: "Meeting Scheduled", count: activityCounts.meetingScheduled },
        { title: "Meeting Done", count: activityCounts.meetingDone },
    ];

    const [query, setQuery] = useState<{
        filter: Record<string, any>;
        lazyParams: {
            first: number;
            rows: number;
            page: number;
            sortField: string;
            sortOrder: number;
        };
    }>({
        filter: {},
        lazyParams: { ...lazyParams },
    });


    const canViewAllContacts = hasPermission("MyLeads", "ViewAllContact");
    const canViewOnlyContacts = hasPermission("MyLeads", "ViewOnlyContact");
    const canHideContacts = hasPermission("MyLeads", "HideContact");
    const canViewRowContacts = hasPermission("MyLeads", "ViewRowContact");
    const canViewNewLeads = hasPermission("MyLeads", "ViewNewLeads");
    const canViewUnderReview = hasPermission("MyLeads", "ViewUnderReview");

    const toggleRequirementRow = (lead: any) => {
        setExpandedLeadId(prev => (prev === lead.leadId ? null : lead.leadId));
    }

    const handleEditLead = (row: ILead) => {
        setSelectedLeads(row);
        setShowForm(true);
    };


    //   useEffect(() => {
    //   setLazyParams((prev) => ({
    //     ...prev,
    //     first: 0,
    //     page: 0,
    //   }));
    // }, [debounceSearch]);

    useEffect(() => {
        setQuery((prev) => ({
            ...prev,
            lazyParams: {
                ...prev.lazyParams,
                first: 0,
                page: 0,
            },
        }));
    }, [debounceSearch]);

    // const loadMyLeads = async () => {
    //   setLoading(true);
    //    const query = new URLSearchParams({
    //               lazyParams: JSON.stringify(lazyParams),
    //               search: debounceSearch,
    //           }).toString();
    //   const res = await fetchApi("Lead/MyLeads", "GET", null, query, "");
    //   if (res) {
    //     setLeadData(res);
    //      setTotalCount(res.totalCount);
    //   }
    //   setLoading(false);
    // };


    const loadMyLeads = async () => {
        setLoading(true);
        const fetchId = ++fetchIdRef.current;

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const params = new URLSearchParams({
            lazyParams: JSON.stringify(query.lazyParams),
            search: debounceSearch,
            filter: JSON.stringify(query.filter ?? {}),
            timeZone: timezone,
        });

        if (dateRange) {
            params.append("startDate", formatDate(dateRange.start));
            params.append("endDate", formatDate(dateRange.end));
        }

        const res = await fetchApi(
            "CreateLead",
            "GET",
            null,
            params.toString(),
            ""
        );

        if (fetchId !== fetchIdRef.current) {
            return;
        }

        // if (res) {
        //   setLeadData(res);
        //   setTotalCount(res.totalCount);
        //   if (Object.keys(query.filter).length === 0) {
        //     setAllStatusCounts(res.statusCounts || []);
        //   }
        //   setStatusCounts(res.statusCounts || []);
        // }

        if (res) {
            setLeadData(res);
            setTotalCount(res.totalCount);

            const sortedCounts = [...(res.statusCounts || [])].sort((a: any, b: any) => {
                return getStatusRank(a.statusName) - getStatusRank(b.statusName);
            });

            setAllStatusCounts(sortedCounts);
            setStatusCounts(sortedCounts);
        }

        setLoading(false);
    };

    const refreshMeetingCount = async (leadId: number) => {
        const res = await fetchApi(
            `LeadRequirement/LeadMeeting?leadId=${leadId}&filter=all`,
            "GET"
        );

        const count = Array.isArray(res?.data)
            ? res.data.length
            : 0;

        setLeadData(prev => ({
            ...prev,
            leads: prev.leads.map(item =>
                item.leadId === leadId
                    ? {
                        ...item,
                        upcomingMeetingCount: count,
                    }
                    : item
            ),
        }));

        loadActivityCounts();
        loadMyLeads();
    };

    const refreshFollowUpCount = async (leadId: number) => {
        const res = await fetchApi(
            `LeadRequirement/LeadFollowUp?leadId=${leadId}&filter=all`,
            "GET"
        );

        const count = Array.isArray(res?.data)
            ? res.data.length
            : 0;

        setLeadData(prev => ({
            ...prev,
            leads: prev.leads.map(item =>
                item.leadId === leadId
                    ? {
                        ...item,
                        upcomingFollowupCount: count,
                    }
                    : item
            ),
        }));

        loadActivityCounts();
        loadMyLeads();
    };



    // useEffect(() => {
    //   loadMyLeads();
    // }, [lazyParams, debounceSearch]);

    useEffect(() => {
        loadFilter();
    }, []);

    useEffect(() => {
        loadMyLeads();
        loadActivityCounts();
    }, [query, debounceSearch, dateRange]);

    const handleViewLead = (lead: ILead) => {
        setViewLead(lead);
        setIsViewOpen(true);
    };

    const handleHistoryLead = (lead: ILead) => {
        setHistoryLead(lead);
        setIsHistoryOpen(true);
    };

    const handleRequirementGatheringForm = (lead: ILead) => {
        setHistoryLead(lead);
        setIsReqGatherFormOpen(true);
    };

    const loadLeadStatuses = async (currentStatus?: string) => {
        const res = await fetchApi(`Lead/GetLeadStatuses`, "GET", null, null);

        if (res) {
            let filteredStatuses = [...res];
            if (currentStatus === "Assigned") {
                filteredStatuses = filteredStatuses.filter(
                    (s: any) => s.statusName !== "Assigned"
                );
            }
            if (currentStatus === "Reassigned") {
                filteredStatuses = filteredStatuses.filter(
                    (s: any) =>
                        s.statusName !== "Assigned" &&
                        s.statusName !== "Reassigned"
                );
            }
            setStatusOptions(
                filteredStatuses.map((s: any) => ({
                    id: s.id,
                    label: s.statusName,
                })).sort((a: any, b: any) => getStatusRank(a.label) - getStatusRank(b.label))
            );
        }
        // if (res) {
        //   setStatusOptions(res.map((s: any) => ({ id: s.id, label: s.statusName })));
        // }
    };


    const loadLeadStatusReasons = async (statusId?: number, initialReasonId?: number) => {
        if (!statusId) {
            setStatusReasonOptions([]);
            return;
        }
        const res = await fetchApi(`Dropdown/statusReason?statusId=${statusId}`, "GET", null, null);
        let options: { id: number; label: string }[] = [];
        if (res && Array.isArray(res)) {
            options = res.map((s: any) => ({
                id: s.id ?? s.statusReasonId,
                label: s.statusReason ?? s.statusReasonName ?? s.name ?? s.label,
            }));
        } else if (res && res.data && Array.isArray(res.data)) {
            options = res.data.map((s: any) => ({
                id: s.id ?? s.statusReasonId,
                label: s.statusReason ?? s.statusReasonName ?? s.name ?? s.label,
            }));
        } else {
            options = [];
        }
        setStatusReasonOptions(options);
        if (initialReasonId) {
            const found = options.find((o) => o.id === initialReasonId);
            if (found) {
                setSelectedStatusReason(found);
            }
        }
    };

    useEffect(() => {
        loadLeadStatuses();
    }, []);

    useEffect(() => {
        if (selectedStatus?.id) {
            loadLeadStatusReasons(selectedStatus?.id);
        } else {
            setStatusReasonOptions([]);
        }
    }, [selectedStatus?.id]);



    /** MASKING STATE */

    const { loginObj } = useAuth();
    const location = useLocation();

    const roleIds = loginObj?.roleId || [];

    const showLeadTypeFilter =
        roleIds.includes(12) && roleIds.includes(13);

    const loadMaskingSettings = async () => {
        const pageId = pageMapping[location.pathname];

        const roleId = loginObj?.roleId?.[0];

        const res = await fetchApi(`FieldMaskingSettings/GetMaskingSettings?pageId=${pageId}&roleId=${roleId}`, "GET");
        if (res) {
            const formatted: any = {};
            res.forEach((item: any) => {
                formatted[item.fieldName] = item.maskType;
            });
            setMaskingSettings(formatted);
        }
    };

    useEffect(() => {
        loadMaskingSettings();
    }, []);


    const maskText = (text?: string) => {
        if (!text) return "";
        return "*".repeat(text.length);
    };


    const toggleReveal = (rowIndex: number, field: string) => {
        if (canViewOnlyContacts) {
            setRevealedField({
                rowIndex,
                field,
            });
            return;
        }
        if (canViewRowContacts) {
            setRevealedRow(rowIndex);
            return;
        }
    };
    const handleUpdateStatus = async () => {
        if (!statusLead || !selectedStatus) return;

        if (statusLead.leadStatusId === selectedStatus.id) {
            addToast({
                message: "Please change the status before updating.",
                status: "warning",
            });
            return;
        }

        if (selectedStatus.label !== "Requirement Gathering" && !description.trim()) {
            addToast({ message: "Description is required", status: "error", });
            return;
        }

        if (statusReasonOptions.length > 0 && !selectedStatusReason) {
            addToast({ message: "Status reason is required", status: "error" });
            return;
        }

        setLoading(true);

        try {
            const payload: any = {
                leadId: statusLead.leadId,
                statusId: selectedStatus.id,
                description,
            };

            if (statusLead?.leadStatusId) {
                payload.previousStatusId = statusLead.leadStatusId;
            }

            if (selectedStatusReason?.id) {
                payload.statusReasonId = selectedStatusReason.id;
            }
            if (selectedStatusReason?.label) {
                payload.statusReason = selectedStatusReason.label;
            }

            if (selectedStatus.id === 16) {
                payload.projectAmount = Number(projectAmount);
                payload.projectDuration = Number(projectDuration);
                payload.projectDurationType = projectDurationType;
            }

            const res = await fetchApi("Lead/UpdateLeadStatus", "PUT", payload);

            if (res) {
                addToast({ message: "Status updated", status: "success", });
                setDescription("");
                setProjectAmount("");
                setProjectDuration("");
                setProjectDurationType(2);
                setSelectedStatus(null);
                setSelectedStatusReason(null);
                setStatusReasonOptions([]);
                setIsStatusOpen(false);
                await loadMyLeads();

            }
        } finally {
            setLoading(false);
        }
    };

    const handleOpenStatusModal = (row: ILead) => {
        setStatusLead(row);
        const defaultStatus = { id: row.leadStatusId ?? 0, label: row.leadStatus ?? "Lead Created", };
        loadLeadStatuses(row.leadStatus); // <-- pass current status

        setSelectedStatus(defaultStatus);
        if (row.statusReasonId) {
            setSelectedStatusReason({
                id: row.statusReasonId,
                label: row.statusReason || "",
            });
        } else {
            setSelectedStatusReason(null);
        }
        if (row.leadStatusId) {
            loadLeadStatusReasons(row.leadStatusId, row.statusReasonId);
        } else {
            setStatusReasonOptions([]);
        }
        setDescription("");
        setProjectAmount("");
        setProjectDuration("");
        setProjectDurationType(2);
        setIsStatusOpen(true);
    };

    const handleCloseStatusModal = () => {
        setIsStatusOpen(false);
        setSelectedStatus(null);
        setSelectedStatusReason(null);
        setStatusReasonOptions([]);
        setDescription("");
        setProjectAmount("");
        setProjectDuration("");
        setProjectDurationType(2);
    };

    //  const handlePageClick = ({ selected }: { selected: number }) => {
    //   const updatedParams = {
    //     ...lazyParams,
    //     page: selected,
    //     first: selected * lazyParams.rows,
    //   };
    //   setLazyParams(updatedParams);
    // };

    const handlePageClick = ({ selected, }: { selected: number; }) => {
        const first = selected * query.lazyParams.rows;
        setQuery((prev) => ({
            ...prev,
            lazyParams: {
                ...prev.lazyParams,
                page: selected,
                first,
            },
        }));
    };

    const loadFilter = async () => {
        const response =
            await fetchApi<IFilterOptions>("Filters/NewLeadFilter", "GET", null, null, "");
        if (response) {
            if (response.filterOptions && response.filterOptions["Status"]) {
                response.filterOptions["Status"] = [...response.filterOptions["Status"]].sort((a: any, b: any) => {
                    return getStatusRank(a.name) - getStatusRank(b.name);
                });
            }
            setFilter(response);
        }
    };

    const handleSort = (option: string) => {
        setSelectedSort(option);

        const sortConfig =
            sortMapping[option];

        if (sortConfig) {
            setQuery((prev) => ({
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    sortField: sortConfig.field,
                    sortOrder: sortConfig.order,
                    page: 0,
                    first: 0,
                },
            }));
        }
    };

    const setRowsPerPage = (rows: number) => {
        setQuery((prev: any) => {
            const updatedParams = {
                ...prev.lazyParams,
                rows,
                page: 0,
                first: 0,
            };

            return {
                ...prev,
                lazyParams: updatedParams,
            };
        });
    };

    const handleCardClick = (title: string) => {
        setSelectedCard(title);

        if (title === "All") {
            setQuery((prev) => ({
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    page: 0,
                    first: 0,
                },
                filter: {
                    ...prev.filter,
                    Status: [],
                    ActivityFilter: "",
                },
            }));
            return;
        }

        const activityTitles = [
            "Reminders",
            "Reminder Done",
            "Meeting Scheduled",
            "Meeting Done",
        ];

        if (activityTitles.includes(title)) {
            setQuery((prev) => ({
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    page: 0,
                    first: 0,
                },
                filter: {
                    ...prev.filter,
                    Status: [],
                    ActivityFilter: title,
                },
            }));
            return;
        }

        const status = filter.filterOptions["Status"]?.find(
            (item) => item.name === title
        );

        if (!status) return;

        setQuery((prev) => ({
            ...prev,
            lazyParams: {
                ...prev.lazyParams,
                page: 0,
                first: 0,
            },
            filter: {
                ...prev.filter,
                ActivityFilter: "",
                Status: [status.id],
            },
        }));
    };

    const loadActivityCounts = async () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const params = new URLSearchParams({
            timeZone: timezone,
            search: debounceSearch,
            filter: JSON.stringify(query.filter ?? {}),
        });

        if (dateRange) {
            params.append("startDate", formatDate(dateRange.start));
            params.append("endDate", formatDate(dateRange.end));
        }

        const res = await fetchApi(
            "Lead/ActivityCounts",
            "GET",
            null,
            params.toString(),
            ""
        );

        if (res) {
            setActivityCounts({
                reminders: res.reminderCount,
                followUpDone: res.followUpDoneCount,
                meetingScheduled: res.meetingScheduledCount,
                meetingDone: res.meetingDoneCount,
            });
        }
    };

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    // const handleDateRangeChange = (dateRange: { start: Date; end: Date } | null) => {
    //     setDateRange(dateRange);

    //     if (dateRange) {
    //         const startStr = formatDate(dateRange.start);
    //         const endStr = formatDate(dateRange.end);

    //         const dateFilterQuery = `startDate=${startStr}&endDate=${endStr}`;

    //         loadMyLeads();
    //     } else {
    //         loadMyLeads();
    //     }
    // };

    const handleDateRangeChange = (
        newRange: { start: Date; end: Date } | null
    ) => {
        setDateRange(prev => {
            if (prev && newRange &&
                prev.start.getTime() === newRange.start.getTime() &&
                prev.end.getTime() === newRange.end.getTime()) {
                return prev;
            }
            return newRange;
        });
    };

    const isRequirementGathering = selectedStatus?.label === "Requirement Gathering";
    return (
        <MyDiv>
            <Box className="top-section">
                <Text className="font-poppins text_xxl text_semibold">Created Leads</Text>
                {/* <CustomButton title="Add New Lead" leftIcon={<AddIcon />} className='btn_theme' onClick={handleAddLead} /> */}
                <Flex align="center" gap={3} >
                    <InputGroup width="250px">
                        <InputLeftElement pointerEvents="none">
                            <Search2Icon color="gray.500" />
                        </InputLeftElement>
                        <Input placeholder="Search by comp/poc name..." value={search} onChange={(e) => setSearch(e.target.value)} bg="white" />
                    </InputGroup>

                    <DateRangePicker
                        maxDate={new Date()}
                        onChange={handleDateRangeChange} showAdvancedFilters={false}
                    //defaultCurrentWeek
                    />
                    {/* FILTER */}
                    <Text fontSize="14px" fontWeight="500">
                        Filter
                    </Text>

                    <Popover placement="bottom-start">
                        <PopoverTrigger>
                            <Button rightIcon={<ChevronDownIcon />} bg="#F9FAFB" border="1px solid #D0D5DD" fontSize="14px" minW="160px" justifyContent="space-between">
                                Filter
                            </Button>
                        </PopoverTrigger>

                        <FilterCard
                            filter={filter}
                            selectedFilters={query.filter}
                            onApply={(filters) => {
                                const _filter: Record<string, any> = {};
                                Object.keys(filters).forEach((key) => {
                                    if (filters[key].length > 0) {
                                        _filter[key.replace(/ /g, "")] = filters[key];
                                    }
                                });

                                if (query.filter.Ownership) {
                                    _filter.Ownership = query.filter.Ownership;
                                }

                                setQuery((prev) => ({
                                    ...prev,
                                    lazyParams: {
                                        ...prev.lazyParams,
                                        page: 0,
                                        first: 0,
                                    },
                                    filter: _filter,
                                }));
                            }}
                        />
                    </Popover>


                    {/* SORT */}

                    <Text fontSize="14px" fontWeight="500" whiteSpace="nowrap">
                        Sort By
                    </Text>

                    <Popover placement="bottom-start" isOpen={isSortOpen} onClose={() => setIsSortOpen(false)}>
                        <PopoverTrigger>
                            <Button rightIcon={<ChevronDownIcon />} bg="#F9FAFB" border="1px solid #D0D5DD" fontSize="14px" minW="180px" justifyContent="space-between" onClick={() => setIsSortOpen(true)} >
                                {selectedSort}
                            </Button>
                        </PopoverTrigger>

                        <PopoverContent w="240px">
                            <Box px={4} py={3} borderBottom="1px solid #E5E7EB" position="relative">
                                <Text textAlign="center" fontSize="14px" fontWeight="500">
                                    Sort By
                                </Text>
                                <PopoverCloseButton top="8px" right="12px" />
                            </Box>

                            <Box maxH="220px" overflowY="auto">
                                {sortOptions.map(
                                    (option) => (
                                        <Box key={option} px={3} py={2} cursor="pointer" bg={selectedSort === option ? "#F3F4F6" : "#FFFFFF"} _hover={{ bg: "#F9FAFB", }} onClick={() => { handleSort(option); setIsSortOpen(false); }}>
                                            <Text fontSize="14px">
                                                {option}
                                            </Text>
                                        </Box>
                                    )
                                )}
                            </Box>
                        </PopoverContent>
                    </Popover>

                </Flex>
            </Box>

            <Grid templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)", xl: "repeat(15, 1fr)", }} gap={2} mt={3}>

                {loading && allStatusCounts.length === 0 ? (
                    <GridItem colSpan={{ base: 1, xl: 17 }}>
                        <Flex className="font-poppins text_medium text_md" justify="center" align="center" minH="80px">
                            Loading...
                        </Flex>
                    </GridItem>
                ) : (
                    <>
                        {[
                            ...allStatusCounts
                                .filter((item: any) => {

                                    if (item.statusName === "Invalid" || item.statusName === "Rejected") {
                                        return false;
                                    }

                                    // Permission-based statuses
                                    if (item.statusName === "New Leads" && !canViewNewLeads) {
                                        return false;
                                    }

                                    if (item.statusName === "Under Review" && !canViewUnderReview) {
                                        return false;
                                    }

                                    return true;
                                })
                                .map((item: any) => ({
                                    key: item.statusId,
                                    title: item.statusName,
                                    count: item.count,
                                    onClick: () => handleCardClick(item.statusName),
                                })),
                            ...count.map((item: any) => ({
                                key: item.title,
                                title: item.title,
                                count: item.count,
                                onClick: () => handleCardClick(item.title),
                            }))
                        ]
                            .sort((a, b) => getStatusRank(a.title) - getStatusRank(b.title))
                            .map((item: any) => (
                                <Box
                                    key={item.key}
                                    cursor="pointer"
                                    onClick={item.onClick}
                                    bg="#FFFFFF"
                                    border={selectedCard === item.title ? "1px solid #2563EB" : "1px solid #c6c8c9"}
                                    borderRadius="8px"
                                    px="6px" py="1px"
                                    boxShadow="0px 1px 3px 0px #0051AF1A" textAlign="center"
                                >
                                    <Text
                                        fontSize="10px"
                                        fontWeight="600"
                                        color={selectedCard === item.title ? "#2563EB" : "#4B5563"}
                                        whiteSpace="nowrap"
                                        overflow="hidden"
                                        textOverflow="ellipsis"
                                    >
                                        {item.title}
                                    </Text>
                                    <Text fontSize="13px" fontWeight="700" color={selectedCard === item.title ? "#2563EB" : "#111827"}>
                                        {item.count}
                                    </Text>
                                </Box>
                            ))}
                    </>
                )}
            </Grid>

            <CreatedLeadList
                loadMyLeads={loadMyLeads}
                maskingSettings={maskingSettings}
                leadData={leadData}
                loading={loading}
                search={search}
                setSearch={setSearch}
                toggleReveal={toggleReveal}
                maskText={maskText}
                handleEditLead={handleEditLead}
                handleViewLead={handleViewLead}
                handleHistoryLead={handleHistoryLead}
                handleOpenStatusModal={handleOpenStatusModal}
                expandedLeadId={expandedLeadId}
                toggleRequirementRow={toggleRequirementRow}
                revealedField={revealedField}
                revealedRow={revealedRow}
                canViewAllContacts={canViewAllContacts}
                canViewOnlyContacts={canViewOnlyContacts}
                canViewRowContacts={canViewRowContacts}
                canHideContacts={canHideContacts}
                onMeetingRefresh={refreshMeetingCount}
                onFollowUpRefresh={refreshFollowUpCount}
                onMessageRefresh={loadMyLeads}

            />

            {/* <Details isOpen={showForm} onClose={() => setShowForm(false)} leads={selectedLeads} loadLead={loadMyLeads}/> */}

            <Drawer isOpen={isViewOpen} placement="right" size="md" onClose={() => setIsViewOpen(false)}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader> Lead Details</DrawerHeader>
                    <DrawerBody>
                        <MyleadViewDrawer lead={viewLead} />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>

            <Drawer isOpen={isHistoryOpen} placement="right" size="lg" onClose={() => setIsHistoryOpen(false)}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>History</DrawerHeader>
                    <DrawerBody>
                        {historyLead?.leadId && (
                            <UniversalActivityHistory
                                module="Lead"
                                recordId={historyLead.leadId}
                            />
                        )}

                        {/* <LeadHistory lead={historyLead} /> */}
                        {/* <MyleadHistory lead={historyLead} /> */}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>

            {/* <LeadRequirementForm isOpen={isReqGatherFormOpen} onClose={() => setIsReqGatherFormOpen(false)} lead={historyLead} /> */}

            <Modal isOpen={isStatusOpen} onClose={handleCloseStatusModal} isCentered>
                <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
                <ModalContent borderRadius="12px" maxW="380px">
                    <ModalHeader>Update Status</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        <Box mb={4}>
                            <Text className="font-poppins text_medium text_md" mb={1}>
                                Select Status
                            </Text>

                            <Select
                                value={selectedStatus?.id || ""}
                                placeholder="Select status"
                                borderRadius="8px"
                                fontSize="13px"
                                onChange={(e) => {
                                    const selected = statusOptions.find((s) => s.id === Number(e.target.value));
                                    setSelectedStatus(selected || null);
                                    setSelectedStatusReason(null);
                                }}
                            >
                                {statusOptions.map((status) => (
                                    <option key={status.id} value={status.id}>
                                        {status.label}
                                    </option>
                                ))}
                            </Select>
                        </Box>

                        {/* Status Reason */}
                        {statusReasonOptions.length > 0 && (
                            <Box mb={4}>
                                <Text className="font-poppins text_medium text_md" mb={1}>
                                    Status Reason <Text as="span" color="red.500">*</Text>
                                </Text>

                                <Select
                                    value={selectedStatusReason?.id || ""}
                                    placeholder="Select status reason"
                                    borderRadius="8px"
                                    fontSize="13px"
                                    onChange={(e) => {
                                        const selected = statusReasonOptions.find(
                                            (s) => s.id === Number(e.target.value)
                                        );
                                        setSelectedStatusReason(selected || null);
                                    }}
                                >
                                    {statusReasonOptions.map((reason) => (
                                        <option key={reason.id} value={reason.id}>
                                            {reason.label}
                                        </option>
                                    ))}
                                </Select>
                            </Box>
                        )}
                        {/* <Box mb={4}>
              <Text className="font-poppins text_medium text_md" mb={1}>
                Select Date
              </Text>

              <Input type="date" value={selectedDate} max={new Date().toISOString().split("T")[0]} min={new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split("T")[0]} onChange={(e) => setSelectedDate(e.target.value)} borderRadius="8px" fontSize="13px" />
            </Box> */}
                        <Box mb={4}>
                            <Text className="font-poppins text_medium text_md" mb={1}> Description{" "}  {!isRequirementGathering && (
                                <Text as="span" color="red.500">  *</Text>)}
                            </Text>

                            <Textarea value={description} onChange={(e) => setDescription(e.target.value)}
                                placeholder="Enter description..." borderRadius="8px" fontSize="13px"
                            />
                        </Box>

                        {/* {selectedStatus?.id === 16 && (
                            <Box p={4} mb={4} bg="blue.50" borderRadius="10px" border="1px solid" borderColor="blue.200">
                                <Text mb={3} fontSize="sm" fontWeight="600" color="blue.800" className="font-poppins">
                                    Project Conversion Details
                                </Text>
                                <VStack spacing={3} align="stretch">
                                    <Box>
                                        <Text mb={1} fontSize="xs" fontWeight="600" color="gray.700" className="font-poppins">
                                            Project Amount (₹) <Text as="span" color="red.500">*</Text>
                                        </Text>
                                        <Input
                                            type="number"
                                            bg="white"
                                            borderRadius="8px"
                                            placeholder="Enter project amount"
                                            value={projectAmount}
                                            onChange={(e) => setProjectAmount(e.target.value)}
                                            className="font-poppins"
                                            size="sm"
                                        />
                                    </Box>
                                    <Box>
                                        <Text mb={1} fontSize="xs" fontWeight="600" color="gray.700" className="font-poppins">
                                            Project Duration <Text as="span" color="red.500">*</Text>
                                        </Text>
                                        <Input
                                            type="number"
                                            bg="white"
                                            borderRadius="8px"
                                            placeholder="Enter duration"
                                            value={projectDuration}
                                            onChange={(e) => setProjectDuration(e.target.value)}
                                            className="font-poppins"
                                            size="sm"
                                        />
                                    </Box>
                                    <Box>
                                        <Text mb={1} fontSize="xs" fontWeight="600" color="gray.700" className="font-poppins">
                                            Duration Type <Text as="span" color="red.500">*</Text>
                                        </Text>
                                        <Select
                                            bg="white"
                                            borderRadius="8px"
                                            value={projectDurationType}
                                            onChange={(e) => setProjectDurationType(Number(e.target.value))}
                                            className="font-poppins"
                                            size="sm"
                                        >
                                            <option value={2}>Months</option>
                                            <option value={1}>Days</option>
                                            <option value={3}>Years</option>
                                        </Select>
                                    </Box>
                                </VStack>
                            </Box>
                        )} */}
                    </ModalBody>

                    <ModalFooter gap={3}>
                        <Button variant="ghost" onClick={handleCloseStatusModal}>
                            Cancel
                        </Button>

                        <Button bg="#4048D6" _hover={{ bg: "#353CC4" }} color="white" onClick={handleUpdateStatus} isLoading={loading} isDisabled={
                            !selectedStatus || (!isRequirementGathering && !description.trim()) || (statusReasonOptions.length > 0 && !selectedStatusReason)}
                        >
                            Update
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {/* {totalCount > 0 && (
        <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick}
          rowsPerPage={lazyParams.rows} rowsPerPageOptions={[10, 50, 100, 200]}
          setRowsPerPage={(value: number) => setLazyParams((prev) => ({ ...prev, rows: value, page: 0, first: 0 }))}
          totalRecords={totalCount} currentPage={lazyParams.page} />
      )} */}


            <Modal
                isOpen={isLegendOpen}
                onClose={() => setIsLegendOpen(false)}
                isCentered
            >
                <ModalOverlay />
                <ModalContent maxW="500px" >
                    <ModalHeader>Lead Status Legend</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody maxH="300px" overflow="scroll">
                        <Grid templateColumns="120px 1fr" gap={3}>
                            <Text fontWeight="700">Short Form</Text>
                            <Text fontWeight="700">Full Form</Text>

                            {statusCounts.map((item: any) => (
                                <>
                                    <Text fontWeight="600">
                                        {item.statusShortName}
                                    </Text>

                                    <Text>
                                        {item.statusName}
                                    </Text>
                                </>
                            ))}
                        </Grid>
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={() => setIsLegendOpen(false)}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {totalCount > 0 && (
                <CustomPagination
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    rowsPerPage={query.lazyParams.rows}
                    rowsPerPageOptions={[50, 100, 200, 500]}
                    setRowsPerPage={setRowsPerPage}
                    totalRecords={totalCount}
                    currentPage={query.lazyParams.page}
                />
            )}
        </MyDiv>
    );
};

export default CreatedLead;
